module.exports = __webpack_public_path__ + "static/media/blueLake.e4a4cc32.jpg";